import { useEffect, useState } from "react";
import { getFeatureFlags } from "./get";
import { FeatureFlags } from "./interfaces";

/**
 * @returns {Object}
 * @example
 * const { flags } = useFeatureFlags();
 * console.log(flags);
 */

export const useFeatureFlags = () => {
  const [flags, setFlags] = useState<FeatureFlags>({
    example: true,
    accountManagement: false,
  });
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    getFeatureFlags().then((newFlags) => {
      setFlags((prevFlags) => ({
        ...prevFlags,
        ...newFlags,
      }));
      setIsLoaded(true);
    });
  }, []);

  return {
    flags,
    isLoaded,
  };
};
